import React from "react";
import { TextField } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles({
  underline: {
    '&:hover:not($disabled):not($focused):not($error):before': {
      borderBottom: "1px solid #26bbed"
    },
    "&:before": {
      borderBottom: "1px solid #dadada"
    },
    "&:after": {
      borderBottom: "1px solid #999999 !important"
    },
  },
  notchedOutline: {
    borderColor: "#dadada",
    borderWidth: "1px !important"
  },
  inputStyle: {
    fontSize: "14px",
    lineHeight: "20px",
    borderRadius: "0px",
    '&:hover $notchedOutline': {
      borderColor: "#26bbed",
    },
    '&$focused $notchedOutline': {
      borderColor: '#999999 !important'
    }
  },
  focused: {
    // borderColor: "red !important"
  },
});

export default (props) => {
  const classes = useStyles()
  return <div >
    <TextField
      {...props}
      InputProps={{
        ...props.InputProps,
        classes: {
          notchedOutline: classes.notchedOutline,
          root: classes.inputStyle,
          focused: classes.focused,
          underline: classes.underline
        },
      }} />
  </div >
}







